$(document).ready(function($){
    if (productInfo.tags.includes("monogramming_bundle*")) {
        // Product is bundle, do custom monogramming functions
        bundleMonogrammingStart();
        return;
    } else {
      console.log("Fail")
    }
  
    const monogrammingSectionWrapper = $("#monogramming-section-wrapper").get(0);
    const button_addMonogram = $('#open-monogramming-app-button').get(0);
    const button_editMonogram = $('#edit-monogramming-button').get(0);
    const button_removeMonogram = $('#remove-monogramming-button').get(0);

    const checkOptionsLoaded = setInterval(() => {
      var options = $("#infiniteoptions-container");
      if (options.children().length > 0) {
        // Options has loaded
    
        // Setup Monogramming Text funtionality
        setupMonogramming()
    
        // Show button
        button_addMonogram.style.display = "block";
        monogrammingSectionWrapper.style.display = "block";
        
        // Cancel Interval
        clearInterval(checkOptionsLoaded);
      }
  }, 500)

  function setupMonogramming() {
    // ----------------------------------------------------------------------------------------
    // CONSTANTS
    // ----------------------------------------------------------------------------------------
    const input_monogramProduct = $(".monogram-product-input");
    const input_monogramLength = $(".monogram-length-input");
    const input_monogramText = $(".monogram-text-input").find("input");
    const input_monogramStyle = $(".monogram-style-input").find("select");
    
    const label_monogramText = $("#monogramming-text");
    
    const button_save = $("#monogramming-modal-save").get(0);
    const button_cancel = $("#monogramming-modal-cancel").get(0);

    const div_savedOptions = $("#monogram-saved-options-id").get(0);
    const label_savedProduct = $("#monogram-saved-product-value");
    const label_savedLength = $("#monogram-saved-length-value");
    const label_savedStyle = $("#monogram-saved-style-value");
    const label_savedText = $("#monogram-saved-text-value");
    
    
    // Modal
    const modal = $("#monogramming-modal").get(0);
    const button_closeModal = $(".modal-close").get(0);
    const formErrorText = $(".form-error-message").get(0);

    // Additional objects
    const wrapper_monogramText = $(".monogram-text-input");

    console.log(productInfo.tags)

    // ----------------------------------------------------------------------------------------
    // FUNCTIONS
    // ----------------------------------------------------------------------------------------
    // Open Monogramming Modal
    function openModal() {
      modal.style.display = "flex";
    }

    function resetText(all) {
      if (productInfo.tags.includes("monogramming_bundle")) {
        all = true;
      }
      if (all == true) {
        input_monogramText.val("");
      }
      label_monogramText.text("");
    }

    // Resets the styling on the monogramming text element (on image)
    function resetMonogramStyle() {
      if (label_monogramText.hasClass("monogram-app-style-blind")) return;
      
      label_monogramText.removeClass("monogram-app-style-gold");
      label_monogramText.removeClass("monogram-app-style-silver");
      label_monogramText.addClass("monogram-app-style-blind");
    }

    function resetInputs() {
      input_monogramProduct.find("input:checked").prop('checked', false);
      input_monogramProduct.find("input:first").trigger('click');

      input_monogramLength.find("input:checked").prop('checked', false);
      input_monogramLength.find("input:first").trigger('click');
      
      input_monogramStyle.prop('selectedIndex',0);
    }

    // Close Monogramming Modal
    function closeModal() {
      modal.style.display = "none";

      // Reset Errors
      formErrorText.style.display = "none";
      input_monogramText.removeClass("form-error-border")
      input_monogramStyle.removeClass("form-error-border");
    }

    function removeMonogram() {
      // Inputs
      resetInputs();

      // Text on image
      resetText(true); // handles input and label
      resetMonogramStyle();

      // Options display
      div_savedOptions.style.display = "none";

      // Buttons
      button_addMonogram.style.display = "block"
      button_editMonogram.style.display = "none"
      button_removeMonogram.style.display = "none"
    }

    // Saving monogram options
    function saveMonogram() {
      // No Monogram Options selected
      // Check if a monogram option is selected
      let options_selected = false;
      
      $(".monogram-length-input").each((i) => {
        if ($(".monogram-length-input").eq(i).find("input:checked").val() != "None" ) {
          // An option is selected as true
          options_selected = true;
        }
      }) 

      if (!options_selected) {
        // No options have been chosen
        // Close modal and don't save
        closeModal();
        removeMonogram();
        return;
      }
      
      // Validate Form
      let valid_form = true;
     
      // Text input
      $(".monogram-text-input").each((i) => {
        if ($(".monogram-text-input")[i].style.display != "none") {
          // Monogram Input
          if (input_monogramText[i].value == "" || !input_monogramText[i].value) {
            // Invalid, add border and set validity variable
            input_monogramText.eq(i).addClass("form-error-border")
            valid_form = false;
          } else {
            // Valid, remove border if exists
            input_monogramText.eq(i).removeClass("form-error-border")
          }
        }
      })

      // Style input
      $(".monogram-style-input").each((i) => {
        if ($(".monogram-style-input")[i].style.display != "none") {
          // Monogram Input
          if (input_monogramStyle[i].value == "" || !input_monogramStyle[i].value) {
            // Invalid, add border and set validity variable
            input_monogramStyle.eq(i).addClass("form-error-border")
            valid_form = false;
          } else {
            // Valid, remove border if exists
            input_monogramStyle.eq(i).removeClass("form-error-border")
          }
        }
      })

      // Form is valid
      if (valid_form) {
        // Save monogram options to product (visual) -- real data is still stored in infinite options form input values which is hidden
        
        div_savedOptions.style.display = "flex";

        let newHTML = "";
        let optionOffset = 0; // Number of option sets set to None

        // Get non-hidden text inputs
        let textInputs = [];
        $(".monogram-text-input").each((j) => {
          // Monogram text inputs
          const textInput = $(".monogram-text-input")[j];
          if (textInput.style.display != "none") {
            // Monogram text input is shown
            textInputs.push($(".monogram-text-input").eq(j).find("input")[0]);
          }
        })
        

        // Get lengths
        $(".monogram-length-input").each((i) => {
          // Add product name
          let productName = $(".monogram-length-input").eq(i).find("label").eq(0).text().replace("Monogramming", "");
          if (productName != "" ) {
            newHTML += `<p>Product: ${productName}</p>`;
          }
          
          
          const lengthInput = $(".monogram-length-input").eq(i).find("input:checked").val();
          if (lengthInput != "None" ) {
            // Add length
            newHTML += `<p>Length: ${lengthInput}</p>`

            // Add text
            console.log(textInputs[i])
            console.log("i:",i)
            console.log("optionOffset", optionOffset)
            // Uses optionOffset to calculate which index to use
            newHTML += `<p>Text: ${textInputs[i - optionOffset].value}</p>`
            

            // Add style
            newHTML += `<p>Style: ${input_monogramStyle[i].value}</p>`
          } else {
            // Product has no monogramming selected
            newHTML += `<p>No Monogramming</p>`;
            // Add offset
            // Monogramming is included
            optionOffset += 1;
          }

          if ($(".monogram-length-input").length - 1 > i) {
            newHTML += `<hr />`
          }
          
        })

        div_savedOptions.innerHTML = newHTML;

        console.log(newHTML);
  
        // console.log(input_monogramLength.find("input:checked"));
        // let desc = input_monogramLength.find("input:checked").parent().html().match(/\d+-\d+ Characters \(\+ /) // 1-3 Characters (+ 
        // let amount = input_monogramLength.find("input:checked").parent().html().match(/\$[\d\.]+ AUD/); // $25.00 AUD
            
        // Replace the text content with the new HTML code that allows for currency conversion
        // label_savedLength.html(`${desc} <span class="money" data-currency-original="${amount}" data-currency-aud="${amount}">${amount}</span>)`);
        // console.log(input_monogramProduct) 
        // if (!input_monogramProduct.find("input:checked").val()) {
        //    label_savedProduct.display = "none"
        //  } else {
        //    console.log(input_monogramProduct)
        //    label_savedProduct.display = "block"
        //     label_savedProduct.html(`Product: ${input_monogramProduct.find("input:checked").val()}`);
        //  }
        
        
        
        // label_savedLength.html(input_monogramLength.find("input:checked").val());
        
        // label_savedText.text(label_monogramText.text());
        // label_savedStyle.text(input_monogramStyle.find(":selected").val());
  
        button_addMonogram.style.display = "none";
        button_removeMonogram.style.display = "block";
        button_editMonogram.style.display = "block";

        closeModal();
      } else {
        formErrorText.style.display = "block";
      }
    }



    // Replaces text $XX.XX AUD with a span containing that price to allow it to work
    // with Currency Converter Plus
    function addCurrencyConversion() {
      // Extract the text using regex
      let $element = $(".monogram-length-input :input");
      $element.each((i) => {
          $curr_elem = $($element[i])
        
          let $parent = $curr_elem.parent();
          let text = $parent.html().match(/>.+\$[\d\.]+ AUD/); // >1-3 Characters (+ $25.00 AUD)
          let desc = $parent.html().match(/\d+-\d+ Characters \(\+ /) // 1-3 Characters (+ 
          let amount = $parent.html().match(/\$[\d\.]+ AUD/); // $25.00 AUD
          
          // Replace the text content with the new HTML code that allows for currency conversion
          $parent.html($parent.html().replace(text, `>${desc} <span class="money" data-currency-original="${amount}" data-currency-aud="${amount}">${amount}</span>`));
      
      });
       
      
    }

    
    // adds the "money" class to the infinite options bundle price so the currency converter
    // can work
    function addClassToIOPrice() {
      $(".price-item").addClass("money")
    }
    
    
    // ----------------------------------------------------------------------------------------
    // ADJUST LENGTH VALUE
    // ----------------------------------------------------------------------------------------
    // The span for price on the IO options value is html escaped when a value
    // This removes the span from the value
        
    // ----------------------------------------------------------------------------------------
    // MODAL DISPLAY
    // ----------------------------------------------------------------------------------------
    button_addMonogram.onclick = openModal;
    button_editMonogram.onclick = openModal;
    button_removeMonogram.onclick = removeMonogram;
    button_closeModal.onclick = closeModal;
    button_save.onclick = saveMonogram;
    button_cancel.onclick = () => {
      removeMonogram(); 
      closeModal();
    };

    input_monogramLength.find("input").change(resetText(true));
    input_monogramProduct.find("input").change(resetText(true));
  
    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
      if (event.target == modal) {
        closeModal()
      }
    }
  
  
    // ----------------------------------------------------------------------------------------
    // MONOGRAMMING INPUT
    // ----------------------------------------------------------------------------------------
    // Handle updating text
    input_monogramText.on("input", (e) => {
      label_monogramText.text(e.target.value)
    })


    // Change monogram text style
    input_monogramStyle.on("change", (e) => {
      // Remove all classes
      label_monogramText.removeClass("monogram-app-style-blind")
      label_monogramText.removeClass("monogram-app-style-gold")
      label_monogramText.removeClass("monogram-app-style-silver")
      
      switch (e.target.value) {
        case "Blind":
          label_monogramText.addClass("monogram-app-style-blind")
          break;
        case "Gold":
          label_monogramText.addClass("monogram-app-style-gold")
          break;
        case "Silver":
          label_monogramText.addClass("monogram-app-style-silver")
          break;
        default:
          // Default to blind
          label_monogramText.addClass("monogram-app-style-blind")
      }
    })

    // Add class to input price to allow it to work with currency converter plus
    // addCurrencyConversion();
    addClassToIOPrice()
  }
})